import $ from 'jquery';
import imagesLoaded from 'imagesloaded';
import LangSelector from "./components/lang-selector";
import SiteHeader from "./components/site-header";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import ScrollInView from "./components/scroll-in-view";
import DeviceManager from "./utils/device-manager";
import ReferenceSlider from './components/references-slider';
// import "./components/map";
import "./components/scollspy";
import "./components/colorbox";
// (function ($) {
	// window.$ = $;

$(function () {

	const bootstrapApp = () => {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}
	}
	
	const instanciateComponents = () => {
		// General components
		const langSelector = new LangSelector($(".language-selector"));
		const siteHeader = new SiteHeader($(".site-header"), 20);

		// Reference slider
		const $homeReferenceSliders = $(".reference-slider__list .swiper-container");
		if ($homeReferenceSliders.length) {
			$homeReferenceSliders.each(function (index, el) {
				const homeReferenceSlider = new ReferenceSlider($(el));
			});
		}

		// Cookie consent
		if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
			// Tarteaucitron cookie settings
			let tarteaucitronLang = "fr";

			const cookiesConsent = new CookiesConsent(tarteaucitronLang);
		}

		// Scroll in view component
		const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
			});
		}
	}

	bootstrapApp();
	instanciateComponents();

});

// })(jQuery);

const mainMenuWrapper = document.querySelector( '.header__nav-wrapper' );
const menuToggler = document.querySelector( '.site-header__menu-toggler' );

if ( mainMenuWrapper && menuToggler ) {
	console.log('here');
	const menuItems = mainMenuWrapper.querySelectorAll( '.menu-item a' );

	menuItems.forEach( item => {
		item.addEventListener( 'click', () => {
			mainMenuWrapper.classList.remove( 'menu--opened' )
			menuToggler.classList.remove( 'menu-toggler--opened' )
		} )
	} )
}